import { useStore } from '@nanostores/react';
import { memo, useCallback, useState } from 'react';
import { ProjectName } from './ProjectName';
import { ProjectVisibility } from './ProjectVisibility';
import { DeleteChat } from '~/components/dialogs/DeleteChat';
import { DangerZoneWrapper } from '~/components/dialogs/settings/DangerZone';
import { SectionContainer } from '~/components/dialogs/settings/SectionContainer';
import { Button } from '~/components/ui/Button';
import { descriptionStore } from '~/lib/stores/description';
import { projectStore } from '~/lib/stores/project';

interface ProjectProps {}

export const Project = memo(({}: ProjectProps) => {
  const [showDeleteChatDialog, setShowDeleteChatDialog] = useState(false);
  const description = useStore(descriptionStore);
  const permissions = useStore(projectStore.permissions);

  const handleOpenDeleteDialog = useCallback(() => {
    setShowDeleteChatDialog(true);
  }, []);

  const handleCloseDeleteDialog = useCallback(() => {
    setShowDeleteChatDialog(false);
  }, []);

  return (
    <SectionContainer title="Project General Settings" className="gap-10">
      <div className="flex flex-col gap-6">
        <ProjectName description={description} canRename={permissions.canRename} />
        <ProjectVisibility canChangeVisibility={permissions.canChangeVisibility} />
      </div>
      <DangerZoneWrapper>
        <div className="flex flex-col text-sm gap-1.5">
          <p className="font-semibold">Delete chat history</p>
          <p className="text-sm max-w-[85%] text-bolt-elements-textSecondary">
            Deleting your messaging history will erase all messages from the chat and the historical context it holds
            along with past versions.
          </p>
        </div>
        <Button color="danger" variant="link-color" className="w-min" onClick={handleOpenDeleteDialog}>
          Delete chat history
        </Button>

        <DeleteChat open={showDeleteChatDialog} onClose={handleCloseDeleteDialog} />
      </DangerZoneWrapper>
    </SectionContainer>
  );
});

Project.displayName = 'ProjectSettings';
